import React from "react";
const GoogleSvg = require("./Google.svg");
const GoogleIcon = () => {
  return <img src={GoogleSvg} />;
};
export default GoogleIcon;
